import dynamic from 'next/dynamic';

const ModalPrinterComparison = dynamic(
  () => import('../modal-printer-comparison/modal-printer-comparison'),
  {
    ssr: false,
  }
);
const ModalInkPlans = dynamic(
  () => import('../modal-ink-plans/modal-ink-plans'),
  {
    ssr: false,
  }
);
const ModalAddPaper = dynamic(
  () => import('../modal-add-paper/modal-add-paper'),
  {
    ssr: false,
  }
);
const ModalCancelling = dynamic(
  () =>
    import('../../../../shared-components/modal-cancelling/modal-cancelling'),
  {
    ssr: false,
  }
);

const selectModal = (modalName: string, isDisabled?: boolean) => {
  switch (modalName) {
    case 'printerComparison':
      return <ModalPrinterComparison />;
    case 'instantInk':
      return <ModalInkPlans isDisabled={isDisabled} />;
    case 'instantPaper':
      return <ModalAddPaper isDisabled={isDisabled} />;
    case 'cancellingPlan':
      return <ModalCancelling />;
    default:
      return null;
  }
};

interface ModalSelectionProps {
  modalName: string;
  isDisabled?: boolean;
}

function ModalSelection({
  modalName,
  isDisabled,
}: Readonly<ModalSelectionProps>) {
  return <div>{selectModal(modalName, isDisabled)}</div>;
}

export default ModalSelection;
